import React from "react";
import { Sankey, Tooltip, ResponsiveContainer } from "recharts";
import DemoSankeyLink from "components/Optimizer/DemoSankeyLink";
import DemoSankeyNode from "components/Optimizer/DemoSankeyNode";

import styles from "./style.module.css";

export default class SankeyChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = { isHide: true };
  }
  render() {
    const { optimized } = this.props;
    const { isHide } = this.state;

    console.log("what is data", data);

    if (optimized === undefined || optimized.first === undefined || optimized.second === undefined) {
      return <div />;
    }

    const fSetup = optimized.first.setup;
    const fTransactionLabel = fSetup.transactionLabel ? fSetup.transactionLabel : "Leads";
    const fNotPursuedTransactionLabel = fSetup.notPursuedTransactionLabel
      ? fSetup.notPursuedTransactionLabel
      : "Potential " + fTransactionLabel;
    const fTrueAction = fSetup.trueAction ? fSetup.trueAction : "Pursue";
    const fFalseAction = fSetup.falseAction ? fSetup.falseAction : "Ignore";

    const sSetup = optimized.second.setup;
    const sTransactionLabel = sSetup.transactionLabel ? sSetup.transactionLabel : "Opportunities";
    const sNotPursuedTransactionLabel = sSetup.notPursuedTransactionLabel
      ? sSetup.notPursuedTransactionLabel
      : "Potential " + sTransactionLabel;
    const sTrueAction = sSetup.trueAction ? sSetup.trueAction : "Pursue";
    const sFalseAction = sSetup.falseAction ? sSetup.falseAction : "Ignore";

    const data = {
      nodes: [
        { name: fTransactionLabel + ": " + fTrueAction },
        {
          name: fTransactionLabel + ": " + fSetup.falsePositiveLabel,
          isNegative: true
        },
        { name: sTransactionLabel },
        { name: sTransactionLabel + ": " + sSetup.truePositiveLabel },
        {
          name: sTransactionLabel + ": " + sSetup.falsePositiveLabel,
          isNegative: true
        },
        {
          name: sTransactionLabel + ": " + sSetup.falseAction,
          isNegative: true
        }
      ],
      links: [
        {
          source: 0,
          target: 2,
          value: Math.round(optimized.first.totalPursued)
        },

        { source: 2, target: 3, value: Math.round(optimized.second.totalWon) },
        {
          source: 2,
          target: 4,
          value: Math.round(optimized.second.totalPursued - optimized.second.totalWon),
          isNegative: true
        },
        {
          source: 2,
          target: 5,
          value: Math.round(optimized.first.totalPursued - optimized.second.totalPursued),
          isNegative: true
        }
      ]
    };

    return (
      <div className={styles.sankeyHolder}>
        <ResponsiveContainer width={"100%"} height={"100%"}>
          <Sankey
            data={data}
            nodeWidth={20}
            nodePadding={isHide ? 100 : 150}
            margin={{
              left: 20,
              right: 20,
              top: 20,
              bottom: 20
            }}
            linkCurvature={0.5}
            iterations={64}
            link={<DemoSankeyLink />}
            node={<DemoSankeyNode containerWidth={960} />}
          >
            <defs>
              <linearGradient id={"falseGradient"}>
                <stop offset="0%" stopColor="rgba(225, 227, 232, 1)" />
                <stop offset="100%" stopColor="rgba(225, 227, 232, 1)" />
              </linearGradient>
              <linearGradient id={"trueGradient"}>
                <stop offset="0%" stopColor="rgba(126, 105, 215, 0.3)" />
                <stop offset="100%" stopColor="rgba(97, 68, 153, 0.5)" />
              </linearGradient>
            </defs>
            <Tooltip />
          </Sankey>
        </ResponsiveContainer>
      </div>
    );
  }
}
